import { useStyletron } from 'baseui'


export default function GroupwareLogo({ styles }) {
  const [css] = useStyletron()
  return (
    <div
      className={css({
		position: 'absolute',
		top: '10%',
		left: '10%',
		transformOrigin: 'center',
        ...styles,
      })}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.5601 18.2397L17.7603 23.0405H6.23981L1.44 18.2397V5.76025L6.23981 0.960449H17.7603L22.5601 5.76025V9.6001H19.44V4.88037C19.44 4.43862 19.0819 4.08069 18.6402 4.08057H5.35992C4.91812 4.08059 4.56012 4.43856 4.56012 4.88037V19.1206C4.56032 19.5622 4.91826 19.9204 5.35992 19.9204H18.6402C19.0818 19.9203 19.4398 19.5622 19.44 19.1206V14.6401H15.3599V11.52H22.5601V18.2397Z" fill="white"/>
      </svg>
    </div>
  )
}


